import Vue from 'vue';
import {
  LIST,
  RECORD_CHANGE,
  CHANGE_USER_STATUS
} from './mutation-types';

export default {

  [LIST](state, response) {
    state.accounts = response.accounts;
    state.total = response.totalCnt;
  },

  [RECORD_CHANGE](state, newItem ) {

    const account = state.accounts.find(item=>item.userId === newItem.userId)
    if(account) {
      if(newItem.status === 'REMOVE') {
          state.accounts.splice(state.accounts.indexOf(account), 1)
      } else {
          state.accounts.splice(state.accounts.indexOf(account), 1, {...account, ...newItem})
      }  
    }  

  },
  [CHANGE_USER_STATUS](state, {userId, status}) {

    const account = state.accounts.find(item=>item.userId === userId)
    if(account) {
        state.accounts.splice(state.accounts.indexOf(account), 1, {...account, status})
    }  

  }


};
